"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:7.3.0'] && _();
}
catch (e) { }
